module.exports = __webpack_public_path__ + "img/Temperature.74499890.svg";